import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';
import FreeTrial from './FreeTrial';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(3),
  },
  answer: {
    padding: theme.spacing(2, 0, 0),
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(1),
  },
}));

const tiers = [
  {
    title: 'Free',
    subheader: 'No credit card required',
    price: '$0',
    value: '1 seat',
    description: [
    'Up to 20 tasks',
    'Free Shopify Ingestion',
    'Data warehouse integration',
    'Github SSO',
    'Help center access',
    'Email support'
    ],
    buttonText: 'Get started for free',
    buttonVariant: 'outlined',
    buttonLink: '/SignUp/',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd'
    }
  },
  {
    title: 'Business',
    subheader: 'The One-click Modern Data Stack',
    price: '$99',
    value: ' per seat per month',
    description: [
      'Unlimited Tasks',
      'Access to 100s of ingestions',
      'Data warehouse integration',
      'Github SSO',
      'Help center access',
      'Email support',
    ],
    buttonText: '14-day Free Trial',
    buttonVariant: 'contained',
    buttonLink: '/FreeTrial',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7',
      textTransform: 'none'
    }
  },
  {
    title: 'Enterprise',
    subheader: 'Tailored to your needs',
    price: 'Contact Us',
    value: 'Unlimited seats',
    description: [
      'Unlimited Tasks',
      'Custom Ingestions and Exports',
      'Data warehouse integration',
      'Custom SSO',
      'Help center access',
      'Phone & email support',
    ],
    buttonText: 'Contact Us',
    buttonVariant: 'outlined',
    buttonLink: '/RequestDemo',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c'
    },
  },
];

export default function Pricing() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

      {/* Hero unit */}
      <Container maxWidth="sm" component="main" className={classes.heroContent}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
        </Box>
        <Typography component="h1" style={{padding:30}} variant="h2" align="center" color="textPrimary" gutterBottom>
          Pricing
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          Start building the future of analytics with FloSQL
        </Typography>
      </Container>
      {/* End hero unit */}

      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item key={tier.title} xs={12} sm={tier.title === 'Business' ? 14 : 6} md={4}>
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center', color: "white" }}
                  action={tier.title === 'Pro' ? <StarIcon /> : null}
                  className={classes.cardHeader}
                  style={tier.style}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h4" variant="h4" color="textPrimary">
                      {tier.price}
                    </Typography>
                  </div>
                  <div className={classes.cardPricing}>
                    <Typography variant="h6" color="textSecondary">
                      {tier.value}
                    </Typography>
                  </div>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component="li" variant="subtitle1" align="center" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button fullWidth href={tier.buttonLink} variant={tier.buttonVariant} style={tier.buttonStyle} color="primary">
                    {tier.buttonText}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}

        </Grid>
      </Container>

      <Container maxWidth="sm" component="main" className={classes.heroContent}>
      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={12} md={12} lg={12} >
      <Box style={{padding:20}}>

        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          Why choose FloSQL?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          FloSQL was built on a foundation of providing the best data engineering tools with uncomprimising quality. With our decades of experience working with data we have been able to ensure our technology has been built for high growth high impact environments. At Base13 Labs we are committed to our customers and their success above all else. For more about us please visit <Link href='/About'>here</Link>.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          What is data orchestration?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          Data orchestration is the process of taking siloed data from multiple data storage locations, combining and organizing it, and making it available for data analysis tools.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          Is there a free trial?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          There is a free version to start building with up to 20 tasks for a single Github user. There currently is a waitlist for the free version. There is also a 14-day free trial of our fully featured FloSQL deployment for businesses. No credit card is required for either option.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        {/*<Typography variant="h5" align="left" color="textPrimary" component="p">
          Are the ingestions free?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          Yes, all of our ingestions are free with our business and enterprise plans as well as up to 3 ingestions with our 14-day free trial.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>*/}
        {/*<Typography variant="h5" align="left" color="textPrimary" component="p">
          Do you have documentation?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          Yes, a full set of our documentation can be found <Link href='/Documentation'>here</Link>.
        </Typography>*/}
        </Box>
        </Grid>
        </Grid>
      </Container>
      <Footer/>
    </React.Fragment>
  );
}
